<template>
  <div class="space-y-3" v-if="user?.favorites?.length">
    <div class="font-heading font-bold text-2xl" v-html="$t('shared.nav.favorites')" />
    <div class="flex flex-col gap-2" v-auto-animate>
      <div v-for="favorite in user?.favorites" :key="`favorite-${favorite.id}`">
        <PartialsTeam :team="favorite" />
      </div>
    </div>
  </div>
</template>

<script setup>
const user = useUserStore()
const { closeDrawer } = useAppDrawer()
</script>